import { c as _c } from "react/compiler-runtime";
import { ExperienceCard } from "@/components/section/journey/ExperienceCard";
import { ExperienceCardMobile } from "@/components/section/journey/ExperienceCardMobile";
import { ExperienceDetail } from "@/components/section/journey/ExperienceDetail";
import { useOnceVisible } from "@/hooks/useOnceVisible";
import { ExperienceEntry } from "@/utils/interfaces";
import { startTransition, useEffect, useRef, useState } from "react";
const journeySectionContent = {
  description: "Explore the milestones that shaped my career in tech.",
  responsibilities: "Key Responsibilities",
  technologies: "Technologies Used"
};
const experienceData: ExperienceEntry[] = [{
  id: "siteground-frontend-developer",
  title: "Software Developer",
  company: "SiteGround",
  location: "Sofia, Bulgaria",
  startDate: "Jan 2026",
  endDate: "Present",
  type: "Current",
  description: "Currently working as a Front-End Software Developer in the Ecommerce Department, leveraging technologies like React, TypeScript, and Tailwind CSS, as well as internal systems, to build and improve a internal site builder platform.",
  responsibilities: ["Building and improving an in-house site builder platform", "Developing front-end solutions for the Ecommerce Department", "Working with React, TypeScript, and internal systems"],
  technologies: ["React", "TypeScript", "Tailwind CSS", "Front-End Development", "Site Builder Platform", "Ecommerce"]
}, {
  id: "limechain-software-developer",
  title: "Software Developer",
  company: "LimeChain - Blockchain & Web3 Solutions",
  location: "Sofia, Bulgaria",
  startDate: "May 2024",
  endDate: "Dec 2025",
  type: "Full-Time",
  description: "I worked as a Software Developer specializing in blockchain and Web3 solutions. My responsibilities included developing front-end applications using React.js, TypeScript, and JavaScript, with a focus on creating user interfaces for decentralized applications (dApps) and blockchain platforms. I worked with modern web technologies including Tailwind CSS to build responsive and performant applications in the Web3 ecosystem.",
  responsibilities: ["Developed front-end applications for blockchain and Web3 solutions", "Built user interfaces for decentralized applications (dApps)", "Implemented responsive designs using modern web technologies"],
  technologies: ["React.js", "TypeScript", "JavaScript", "Front-End Development", "Web3", "Blockchain", "Tailwind CSS"]
}, {
  id: "mentormate-software-developer",
  title: "Software Developer",
  company: "MentorMate",
  location: "Sofia, Bulgaria",
  startDate: "Mar 2023",
  endDate: "Apr 2024",
  type: "Full-Time",
  description: "I worked as a Front End software developer for a social media platform project. My responsibilities included utilizing technologies such as React, TypeScript, React Query, React Testing Library, Chakra UI, and Jest to develop the user interface and ensure a user-friendly design and optimal functionality. The project followed Agile methods and employed tools like Jira and Confluence.",
  responsibilities: ["Developed and maintained user interface components for a social media platform", "Implemented responsive designs ensuring optimal functionality across devices", "Collaborated with cross-functional teams using Agile methodologies"],
  technologies: ["React", "TypeScript", "React Query", "React Testing Library", "Chakra UI", "Jest", "Jira", "Confluence"]
}, {
  id: "mentormate-junior-developer",
  title: "Junior Software Developer",
  company: "MentorMate",
  location: "Sofia, Bulgaria",
  startDate: "Apr 2022",
  endDate: "Mar 2023",
  type: "Full-Time",
  description: "I worked for a US-based client on an e-commerce platform project. Encompassing Front End technologies including React, JavaScript, TypeScript, React Query, React Testing Library, and Jest. As well as Back End technologies such as Python, Django REST Framework, and Unit Testing.",
  responsibilities: ["Built e-commerce platform features for American client", "Developed both frontend and backend components", "Implemented unit testing for quality assurance"],
  technologies: ["React", "JavaScript", "TypeScript", "React Query", "React Testing Library", "Jest", "Python", "Django REST Framework"]
}, {
  id: "mentormate-trainee",
  title: "Software Development Trainee",
  company: "MentorMate",
  location: "Sofia, Bulgaria",
  startDate: "Feb 2022",
  endDate: "Mar 2022",
  type: "Certification",
  description: "Completed Mentormate DevCamp (University) - Python. Intensive training program covering Python fundamentals, Django framework, database management, and web development best practices.",
  responsibilities: ["Completed intensive Python development bootcamp", "Learned Django framework and database management", "Acquired web development best practices"],
  technologies: ["Python", "Django", "MySQL", "HTML5", "CSS3"]
}];
interface JourneySectionProps {
  title: string;
}
export const JourneySection = t0 => {
  const $ = _c(38);
  const {
    title
  } = t0;
  const [selectedExperience, setSelectedExperience] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const [displayedExperience, setDisplayedExperience] = useState(experienceData[0].id);
  const [expandedMobileCard, setExpandedMobileCard] = useState(null);
  const animationTimerRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setSelectedExperience(experienceData[0].id);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    ref: sectionRef,
    cancel: cancelInitialSelection
  } = useOnceVisible(t1);
  let t2;
  if ($[1] !== cancelInitialSelection) {
    t2 = id => {
      cancelInitialSelection();
      setSelectedExperience(id);
    };
    $[1] = cancelInitialSelection;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleExperienceSelect = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = id_0 => {
      setExpandedMobileCard(prev => prev === id_0 ? null : id_0);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleMobileToggle = t3;
  let t4;
  if ($[4] !== displayedExperience) {
    t4 = experienceData.find(exp => exp.id === displayedExperience) || experienceData[0];
    $[4] = displayedExperience;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const activeExperience = t4;
  const shouldTransition = selectedExperience !== null && selectedExperience !== displayedExperience;
  let t5;
  let t6;
  if ($[6] !== selectedExperience || $[7] !== shouldTransition) {
    t5 = () => {
      if (shouldTransition) {
        if (animationTimerRef.current) {
          clearTimeout(animationTimerRef.current);
        }
        startTransition(() => {
          setIsAnimating(true);
        });
        animationTimerRef.current = setTimeout(() => {
          startTransition(() => {
            setDisplayedExperience(selectedExperience);
            setIsAnimating(false);
          });
        }, 300);
      }
      return () => {
        if (animationTimerRef.current) {
          clearTimeout(animationTimerRef.current);
          animationTimerRef.current = null;
        }
      };
    };
    t6 = [shouldTransition, selectedExperience];
    $[6] = selectedExperience;
    $[7] = shouldTransition;
    $[8] = t5;
    $[9] = t6;
  } else {
    t5 = $[8];
    t6 = $[9];
  }
  useEffect(t5, t6);
  let t7;
  if ($[10] !== title) {
    t7 = <h1 id="journey-heading" className="heading-1 mb-6 text-glow">{title}</h1>;
    $[10] = title;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className="body-large">{journeySectionContent.description}</p>;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t7) {
    t9 = <header className="max-w-3xl text-center mb-8">{t7}{t8}</header>;
    $[13] = t7;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== expandedMobileCard) {
    t10 = experienceData.map(experience => <ExperienceCardMobile key={experience.id} experience={experience} isExpanded={expandedMobileCard === experience.id} onToggle={() => handleMobileToggle(experience.id)} responsibilitiesLabel={journeySectionContent.responsibilities} technologiesLabel={journeySectionContent.technologies} />);
    $[15] = expandedMobileCard;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <div className="w-full flex flex-col gap-4 lg:hidden" role="list" aria-label="Experience timeline">{t10}</div>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== handleExperienceSelect || $[20] !== selectedExperience) {
    t12 = experienceData.map(experience_0 => {
      const isActive = experience_0.id === selectedExperience;
      return <ExperienceCard key={experience_0.id} experience={experience_0} isActive={isActive} onClick={() => handleExperienceSelect(experience_0.id)} />;
    });
    $[19] = handleExperienceSelect;
    $[20] = selectedExperience;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12) {
    t13 = <div className="flex flex-col gap-4" role="list" aria-label="Experience timeline">{t12}</div>;
    $[22] = t12;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== activeExperience || $[25] !== displayedExperience || $[26] !== isAnimating) {
    t14 = displayedExperience && <ExperienceDetail key={displayedExperience} experience={activeExperience} isAnimating={isAnimating} responsibilitiesLabel={journeySectionContent.responsibilities} technologiesLabel={journeySectionContent.technologies} />;
    $[24] = activeExperience;
    $[25] = displayedExperience;
    $[26] = isAnimating;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t14) {
    t15 = <article className="lg:sticky lg:top-6 h-fit min-h-80" aria-live="polite" aria-atomic="true">{t14}</article>;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== t13 || $[31] !== t15) {
    t16 = <div className="w-full hidden lg:grid lg:grid-cols-2 gap-6">{t13}{t15}</div>;
    $[30] = t13;
    $[31] = t15;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== sectionRef || $[34] !== t11 || $[35] !== t16 || $[36] !== t9) {
    t17 = <section ref={sectionRef} aria-labelledby="journey-heading" className="w-full flex flex-col items-center gap-4 max-w-7xl">{t9}{t11}{t16}</section>;
    $[33] = sectionRef;
    $[34] = t11;
    $[35] = t16;
    $[36] = t9;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  return t17;
};